import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";

export default function Layout() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
    }, [location.pathname]);

    return (
        <div className="flex min-h-screen flex-col bg-offwhite text-charcoal" data-testid="layout-root">
            <Navbar />
            <main className="flex-1" data-testid="main-content">
                <Outlet />
            </main>
            <Footer />
            <CookieConsent />
        </div>
    );
}
